let t = {};
const n = () => t, s = (e) => t = Object.assign({}, t, e), c = (e) => t[e] === "true" || t[e] === !0;
export {
  n as getEnv,
  c as hasEnabledFlag,
  s as setEnv
};
